'use client'

import Popover from '@/app/components/ui/overlays/popover'
import { LogOut, User } from 'lucide-react'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { useState } from 'react'
import useSession from './hooks/use-session'

export function UserDropdown() {
  const { push } = useRouter()
  const { session } = useSession()
  const { name, avatarUrl } = session as any

  const [openPopover, setOpenPopover] = useState(false)

  return (
    <div className="relative inline-block text-left">
      <Popover
        content={
          <div className="w-full rounded-md bg-white p-2 sm:w-56">
            {/* <Link
              className="relative flex items-center justify-start w-full p-2 space-x-2 text-sm text-left transition-all duration-75 rounded-md hover:bg-primary hover:text-white"
              href="/dashboard"
            >
              <LayoutDashboard className="w-4 h-4" />
              <p className="text-sm">Dashboard</p>
            </Link> */}
            <button
              className="relative flex w-full items-center justify-start space-x-2 rounded-md p-2 text-left text-sm transition-all duration-75 hover:bg-primary hover:text-white"
              onClick={() => {
                window.location.href = '/pages/public/account.html'
              }}
            >
              <User className="h-4 w-4" />
              <p className="text-sm">My Account</p>
            </button>
            <div className="m-1.5 h-[1px] bg-primary"></div>
            <button
              className="relative flex w-full items-center justify-start space-x-2 rounded-md p-2 text-left text-sm transition-all duration-75 hover:bg-primary hover:text-white"
              onClick={() => {
                push('/logout')
              }}
            >
              <LogOut className="h-4 w-4" />
              <p className="text-sm">Logout</p>
            </button>
          </div>
        }
        align="end"
        openPopover={openPopover}
        setOpenPopover={setOpenPopover}
      >
        <button
          type="button"
          title="User Menu"
          onClick={() => setOpenPopover(!openPopover)}
          className="flex h-8 w-8 items-center justify-center overflow-hidden rounded-full border border-gray-300 transition-all duration-75 focus:outline-none active:scale-95 sm:h-12 sm:w-12"
        >
          <Image
            alt={'avatar'}
            src={
              avatarUrl || encodeURI(`https://api.dicebear.com/6.x/initials/svg?seed=${name}&backgroundColor=1f5c82`)
            }
            width={48}
            height={48}
          />
        </button>
      </Popover>
    </div>
  )
}

export default UserDropdown
